import React from 'react';

class BarChart extends React.Component {
  componentDidMount() {
    const barCharts = document.querySelectorAll('.bar-chart--horizontal');

    for(let i = 0; i < barCharts.length; i++) {
      const el = barCharts[i];
      const labels = el.querySelectorAll('.bar-chart--horizontal .bar-chart__label');
      const bars = el.querySelectorAll('.bar-chart--horizontal .bar-chart__bar');
      const texts = el.querySelectorAll('.bar-chart--horizontal .bar-chart__text');
      let labelWidth = 0;
      let barMax = 0;

      for(let j = 0; j < labels.length; j++) {
        const thisWidth = Math.ceil(labels[j].getBoundingClientRect().width);
        if(thisWidth > labelWidth) {
          labelWidth = thisWidth + 50;
        }

        const thisVal = parseFloat(bars[j].getAttribute('width'))
        if(thisVal > barMax) {
          barMax = thisVal;
        }
      }

      el.style.paddingLeft = labelWidth;

      for(let k = 0; k < bars.length; k++) {
        const bar = bars[k];
        const text = texts[k];

        // Set width to percentage of the max
        const barWidthAttr = parseFloat(bar.getAttribute('width'));
        let barWidth = 0;

        // If the bar’s width attribute is greater than 0
        if(barWidthAttr > 0) {
          barWidth = (parseFloat(bar.getAttribute('width')) / barMax) * 100;
        }

        bar.style.width = barWidth + '%';
        text.setAttribute('x', barWidth + '%');

        // Timeout to add width inrementally and animate. Commented out because it got annoying.
        // setTimeout(function(){
        //   bar.style.width = barWidth + '%';
        //   text.setAttribute('x', barWidth + '%');
        // }, 500 + (25 * k));
      }
    }
  }

  // IE10 and Safari don’t like the text-anchor property, so we need to do something else for it
  renderLabel(i, key, ie, safari) {
    function formatStatus(status) {
      switch (status) {
        case 'needsProctor':
          return 'Needs Proctor'

        case 'pendingApproval':
          return 'Pending Approval'

        case 'approvalDenied':
          return 'Approval Denied'

        case 'inProgress':
          return 'In Progress'

        default:
          return status;
      }
    }

    if(!ie && !safari) {
      return (
        <text className="bar-chart__label" textAnchor="end" x="-10" dy="1.1em" y={(i * 20) + (i * 2)}>{formatStatus(key)}</text>
      )
    } else {
      return (
        <g>
          <rect className="bar-chart__label-bg" width="100" height="20" dy="1.1em" y={(i * 20) + (i * 2)}></rect>
          <text className="bar-chart__label" dy="1.1em" y={(i * 20) + (i * 2)}>{formatStatus(key)}</text>
        </g>
      )
    }
  }

  // IE10 also apparently is no good at rendering the correct height on an SVG
  // unless it is explicitly set as a style rather than the height attribute
  sizeChart(data, ie) {
    let style = null;

    if(ie) {
      style = {
        height: (Object.keys(data).length * 20) + ((Object.keys(data).length - 1) * 2) + 40 + 'px'
      }
    }

    return style;
  }

  render() {
    let { data } = this.props;
    let total = 0;
    let ie = false;
    let safari = false;
    let barOffset = 0;

    if(data.hasOwnProperty('incident')) {
      delete data.incident;
    }

    if(document.querySelector('html').className.indexOf('ie-true') > -1) {
      ie = true;
      barOffset = 100;
    }

    if(document.querySelector('html').className.indexOf('safari') > -1) {
      safari = true;
      barOffset = 100;
    }

    if(data && typeof data !== 'undefined' && !Array.isArray(data)) {
      // Get the total number of students from the summary
      Object.keys(data).map(
        (key, i) =>
        total += data[key]
      )

      // Make sure total is at least 1 to avoid dividing by 0
      if(total === 0) {
        total = 1;
      }

      return(
        <svg
          className="bar-chart bar-chart--horizontal"
          height={(Object.keys(data).length * 20) + ((Object.keys(data).length - 1) * 2)}
          role="img"
          aria-labelledby={`chart-title-${this.props.i}`}
          aria-describedby={`chart-description-${this.props.i}`}
          style={this.sizeChart(data, ie, safari)}
        >
          <title id={`chart-title-${this.props.i}`}>{this.props.title}</title>
          <desc id={`chart-description-${this.props.i}`}>{Object.keys(data).map((key, i) =>`${key} ${data[key]}, `)}</desc>

          {Object.keys(data).map(
            (key, i) => {
              return (
                <g key={i}>
                  <rect
                    className={`bar-chart__bar ${key} `}
                    width={`${((data[key]/total) * 100).toFixed(0)}%`}
                    height="20" y={(i * 20) + (i * 2)}
                    x={barOffset}
                  ></rect>
                  {this.renderLabel(i, key, ie, safari)}
                  <text className="bar-chart__text" x="5" dy="1.1em" y={(i * 20) + (i * 2)}>{data[key]}</text>
                </g>
              )
            }
          )}
        </svg>
      )
    }

    return null;
  }
}

export default BarChart;


// WEBPACK FOOTER //
// ./src/app/components/BarChart/BarChart.js